import { Box, Text, FormattedAmount } from "@ui-kit/components/index.es";
import React from "react";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import { bool, number, shape, arrayOf } from "prop-types";

function Limits(props) {
    Limits.propTypes = {
        isDesktop: bool.isRequired,
        values: shape({}).isRequired,
        currency: number.isRequired,
        limit: number.isRequired,
        limitUsed: number.isRequired,
        limits: arrayOf(shape({})).isRequired,
    };

    const { isDesktop, values, limit, limitUsed, currency, limits } = props;
    const currencyLabel = () => (currency ? i18n.get(`currency.label.${currency}`) : "");
    const isTemporaryLimitEnabled = configUtils.getBoolean("frontend.temporarilyincreaselimit.functionalities");
    const clampAvailable = (amount) => (isTemporaryLimitEnabled && amount < 0 ? 0 : amount);

    const getTruncNumber = (value) => {
        const numberText = value?.toString();
        const index = numberText?.indexOf(".");

        if (!numberText || index === -1) {
            return value;
        }
        const end = numberText.length >= index + 3 ? index + 3 : index + 2;
        return parseFloat(numberText.slice(0, end));
    };

    const convertAmountByCurrency = (amount) => {
        if (currency === "2") {
            const dolarQuot = parseFloat(configUtils.get("CMF_Dolar_Valor", "98.90"));
            return getTruncNumber(amount / dolarQuot);
        }
        return amount;
    };

    if (!values.debitAccount) {
        return null;
    }

    const cbuLimit = limits?.find((l) => l.type === "CBU");
    const limitVar = convertAmountByCurrency(cbuLimit?.limit || limit);
    const limitUsedVar = convertAmountByCurrency(cbuLimit?.limitUsed || limitUsed);

    const withoutMenu = window.innerWidth >= 1370;
    const showCVUTransfers = configUtils.getBoolean("frontend.show.transfers.services.Coelsa.CVU.functionalities");
    if (isDesktop && withoutMenu && !showCVUTransfers) {
        return (
            <Box flex align="baseline">
                <Text color="primary" variant="bodyBold" className="no-wrap">
                    {i18n.get("transfers.form.limit")}
                </Text>
                <FormattedAmount color="primary" variant="body2" amount={limitVar} currency={currencyLabel()} />
                <Box mx={8}>
                    <Text color="primary" variant="body2">
                        |
                    </Text>
                </Box>
                <Text color="primary" variant="bodyBold" className="no-wrap">
                    {i18n.get("transfers.form.limit.available")}
                </Text>
                <FormattedAmount
                    color="primary"
                    variant="body2"
                    amount={clampAvailable(limitUsedVar)}
                    currency={currencyLabel()}
                />
            </Box>
        );
    }
    const renderLimitRow = (limitLabel, limitAmount, availableLabel, availableAmount) => (
        <Box flex align="baseline" gap={4} wrap>
            <Box flex align="baseline" gap={4}>
                <Text color="primary" variant="bodyBold" className="no-wrap">
                    {limitLabel}
                </Text>
                <FormattedAmount color="primary" variant="body2" amount={limitAmount} currency={currencyLabel()} />
            </Box>
            <Text color="primary" variant="body2">
                |
            </Text>
            <Box flex align="baseline" gap={4}>
                <Text color="primary" variant="bodyBold" className="no-wrap">
                    {availableLabel}
                </Text>
                <FormattedAmount color="primary" variant="body2" amount={availableAmount} currency={currencyLabel()} />
            </Box>
        </Box>
    );

    if (showCVUTransfers) {
        return (
            <Box column={!isDesktop} flex={isDesktop} wrap={isDesktop} gap={!isDesktop ? 8 : 0}>
                {limits?.map((limitObj) => {
                    const limitType = limitObj.type.toLowerCase();
                    return (
                        <Box mr={isDesktop ? 4 : 0} key={limitType}>
                            {renderLimitRow(
                                i18n.get(`transfers.form.limit.${limitType}`),
                                convertAmountByCurrency(limitObj.limit),
                                i18n.get(`transfers.form.limit.available.${limitType}`),
                                clampAvailable(convertAmountByCurrency(limitObj.limitUsed)),
                            )}
                        </Box>
                    );
                })}
            </Box>
        );
    }

    if (!showCVUTransfers) {
        return renderLimitRow(
            i18n.get("transfers.form.limit"),
            limitVar,
            i18n.get("transfers.form.limit.available"),
            clampAvailable(limitUsedVar),
        );
    }
}

export default Limits;
